export const faucetAmoy = [
  {
    title: "Cómo solicitar POL de prueba en la red Amoy (Polygon Testnet) usando la faucet oficial",
    value: `
Sigue estos pasos detallados para obtener POL de testnet en la red Amoy a través de la faucet oficial de Polygon.  
**Es necesario contar con al menos 0.001 POL en la red principal (Polygon Mainnet)**, ya que la faucet exige este saldo mínimo para evitar el abuso y garantizar que solo usuarios reales puedan recibir tokens de prueba.

---

1. **Verifica tu saldo en la red principal**  
   Antes de solicitar POL en la testnet, asegúrate de tener al menos **0.001 POL** en tu wallet dentro de la red principal de Polygon (Mainnet).  
   Esto es un requisito de la faucet y, sin este saldo, la solicitud será rechazada.  
   Si no tienes el saldo suficiente, puedes adquirir POL en un exchange y transferirlo a tu wallet principal.
   ![Verifica tu saldo en Mainnet](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/10-1.png)

2. **Conéctate a MetaMask en la red Polygon Mainnet**  
   Abre MetaMask y selecciona la red "Polygon Mainnet" en la parte superior.  
   Confirma que tu saldo de POL cumpla el mínimo requerido. Si no es así, realiza una transferencia desde tu exchange de preferencia.
   ![Conéctate a Polygon Mainnet](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/10-2.png)

3. **Accede a la faucet oficial de Amoy**  
   Ingresa al sitio web oficial de la faucet: [https://faucet.polygon.technology/](https://faucet.polygon.technology/)  
   La faucet te permitirá recibir hasta 0.1 POL de prueba en la red Amoy cada 72 horas, pero solo si cumples el saldo mínimo en Mainnet.
   ![Accede a la faucet de Amoy](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/10-3.png)

4. **Copia y pega tu dirección pública**  
   Abre MetaMask, copia tu dirección pública (empieza con 0x…) y pégala en el campo correspondiente de la página de la faucet.
   ![Pega tu dirección pública](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/10-4.png)

5. **Verifica el Captcha**  
   Marca la casilla “No soy un robot” para pasar la verificación de seguridad y permitir que el sistema procese tu solicitud.
   ![Verifica el Captcha](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/10-4.png)

6. **Solicita POL y espera la confirmación**  
   Haz clic en el botón **Send Me POL**.  
   La página mostrará un mensaje de confirmación y, si todo es correcto, tu solicitud será procesada. Recibirás **0.1 POL en la red Amoy**. Recuerda: la faucet solo permite una solicitud por dirección cada 72 horas.
   ![Haz clic en Send Me POL](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/10-5.png)

7. **Cambia a la red Amoy y verifica tu saldo**  
   Finalmente, abre MetaMask y cambia la red a **Amoy**.  
   Revisa que tu saldo de POL de prueba ya haya sido acreditado. Si no lo ves de inmediato, espera unos minutos y actualiza la interfaz.
   ![Verifica tu saldo en Amoy](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/10-6.png)

---

**¿Por qué necesitas POL en Mainnet para solicitar POL de testnet?**  
Este requisito ayuda a prevenir abusos y automatizaciones, asegurando que solo usuarios reales con fondos en Polygon Mainnet accedan a los recursos de prueba.  
El POL de testnet **NO tiene valor real** y es únicamente para pruebas, simulaciones y desarrollo en la red Amoy.

![Verifica tu saldo en Amoy](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/10-7.png)

¡Ahora puedes experimentar y desplegar contratos en la red Amoy usando tus POL de prueba!


`
  }
];

export default faucetAmoy;
